/* eslint-disable @typescript-eslint/naming-convention */
import { FuncOrGroup } from '@react-awesome-query-builder/antd';

const MIN = (customFields: any): FuncOrGroup => ({
  label: 'MIN',
  sqlFunc: 'MIN',
  returnType: 'number',
  args: {
    numbers: {
      label: 'Numbers',
      type: 'number',
      valueSources: ['value','func','field'],
      listValues: Object.keys(customFields),
      allowCustomValues: true,
      // Removed: multi: true - now it's a single value
    },
    valueOrFunc: {
      label: 'Value or Function',
      type: 'number',
      valueSources: ['value', 'func'],
      allowCustomValues: true
    }
  },
  allowSelfNesting: true,
  jsonLogic: (formattedArgs) => {
    // numbers is now a single value, not a comma-separated string
    const selectedField = formattedArgs.numbers ? { var: formattedArgs.numbers } : null;
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    let options = [];
    
    if (selectedField) {
      options.push(selectedField);
    }
    
    if (valueOrFunc) {
      if (typeof valueOrFunc === 'object' && valueOrFunc.func) {
        options.push(valueOrFunc);
      } else {
        options.push(valueOrFunc);
      }
    }
    
    return {
      min: options
    };
  },
  formatFunc: (formattedArgs) => {
    const selectedField = formattedArgs.numbers || '';
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    if (selectedField && valueOrFunc) {
      return `MIN(${selectedField}, ${valueOrFunc})`;
    } else if (selectedField) {
      return `MIN(${selectedField})`;
    } else if (valueOrFunc) {
      return `MIN(${valueOrFunc})`;
    }
    return 'MIN()';
  },
  sqlFormatFunc: (formattedArgs) => {
    const selectedField = formattedArgs.numbers || '';
    const valueOrFunc = formattedArgs.valueOrFunc;
    
    if (selectedField && valueOrFunc) {
      return `MIN(${selectedField}, ${valueOrFunc})`;
    } else if (selectedField) {
      return `MIN(${selectedField})`;
    } else if (valueOrFunc) {
      return `MIN(${valueOrFunc})`;
    }
    return 'MIN()';
  }
});

export default MIN;